export enum Discipline {
    VertriebVerkauf = "Vertrieb & Verkauf",
    MarketingKommunikation = "Marketing & Kommunikation",
    OperationsServiceCustomerCare = "Operations & Service & Customer Care",
    ProjektVeranstaltungsmanagement = "Projekt- & Veranstaltungsmanagement",
    Produktmanagement = "Produktmanagement",
    ITEntwicklung = "IT / Entwicklung",
    AdministrationAssistenz = "Administration & Assistenz",
    PersonalRecht = "Personal & Recht",
    FinanzenControlling = "Finanzen & Controlling",
    StrategieBusinessDevelopment = "Strategie & Business Development",
    Einkauf = "Einkauf"
}